export default "__VITE_ASSET__ClTFQgX___"